<template>
    <div class="tabs">
        <div
            :id="`btn-talk-${tab.id}`"
            class="tab"
            v-for="tab in tabs"
            :key="'tab-' + tab.id"
            :class="{
                [`${module}-tab-active`]: tab.active,
                disabled: loading,
                'tab-active': tab.active,
                [`tab-${size}`]: true,
            }"
            @click="onClickTabHandler(tab)"
        >
            <span class="tab-title">
                {{ tab.title }}
                <b-badge
                    pill
                    class="ml-2"
                    variant="danger"
                    v-if="showBadge(tab) && badgeCount"
                    >{{ badgeCount }}</b-badge
                >
            </span>
        </div>
        <span class="underline" ref="underline"></span>
    </div>
</template>

<script>
const MARGIN_MODIFIER = 5
const WIDTH_MODIFIER = 10

export default {
    name: 'Tabs',
    props: {
        tabs: Array,
        badgeCount: {
            type: Number,
            default: 0,
        },
        loading: Boolean,
        module: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: 'md',
            validator: (val) => ['sm', 'md', 'lg'].includes(val),
        },
    },
    mounted() {
        setTimeout(() => {
            this.handleUnderlinePosition()
        }, 1000)
    },
    methods: {
        onClickTabHandler({ id }) {
            if (this.loading) {
                return
            }
            const activeTab = this.tabs.find((t) => t.active)

            if (activeTab.id === id) {
                return
            }

            this.setNewActiveTab(id, activeTab)
            setTimeout(() => {
                this.handleUnderlinePosition()
            }, 50)
            this.$emit('tabChange', id)
        },
        setNewActiveTab(id, activeTab) {
            const newActiveTabIndex = this.tabs.findIndex((t) => t.id == id)
            const previousActiveTabIndex = this.tabs.findIndex(
                (t) => t.id == activeTab.id
            )

            this.tabs[previousActiveTabIndex].active = false
            this.tabs[newActiveTabIndex].active = true
        },
        handleUnderlinePosition() {
            const activeTab = this.getActiveTabElement()
            const underline = this.getUnderlineElement()
            if (!activeTab) {
                return
            }

            return this.calcUnderlinePosition(activeTab, underline)
        },
        calcUnderlinePosition(activeTab, underline) {
            const activeTabBeggining = activeTab.offsetLeft - MARGIN_MODIFIER
            const acitveTabWidth = activeTab.offsetWidth + WIDTH_MODIFIER
            underline.style.left = `${activeTabBeggining}px`
            underline.style.width = `${acitveTabWidth}px`
            underline.style.opacity = 1
        },
        getActiveTabElement() {
            return document.getElementsByClassName(
                `${this.module}-tab-active`
            )[0]
        },
        getUnderlineElement() {
            return this.$refs['underline']
        },
        showBadge(tab) {
            return tab.badge
        },
    },
    watch: {
        tabs() {
            setTimeout(() => {
                this.handleUnderlinePosition()
            }, 50)
        },
    },
}
</script>

<style lang="sass" scoped>
$grey: #808080
$blue: #009BDB
.tabs
    display: flex
    justify-content: space-around
    align-items: center
    flex-direction: row
    flex-wrap: wrap
    padding: 20px 0px
    background-color: #fff
    position: relative
    overflow: hidden
    width: 100%
    .tab
        cursor: pointer
        text-align: center
        flex: 0 0 50%
        position: relative
        .tab-title
            color: $grey
            font-weight: 600
            .tab-title
                color: $blue
    .tab-sm
        width: 70px
        .tab-title
            font-size: 12px
    .tab-md
        width: 150px
        margin: 5px 0
        padding: 5px
        .tab-title
            font-size: 15px
    .tab-lg
        width: 250px
        .tab-title
            font-size: 17px
    .tab-active
        &:before
            content: ''
            position: absolute
            height: 2px
            left: 50%
            bottom: -1px
            width: 50%
            display: block
            background-color: $blue
            transform: translateX(-50%)

        .tab-title
            color: $blue
    .disabled
        cursor: not-allowed
        &:hover
            .tab-title
                color: $grey
    .underline
        display: none
        position: absolute
        height: 2px
        background-color: $blue
        left: 0px
        bottom: 20px
        transition: 0.3s ease all
        opacity: 0

@media (min-width: 600px)
    .tabs
        flex-direction: row
        padding: 20px 30px
        width: auto
        .tab
            flex: auto
        .tab-sm,
        .tab-md,
        .tab-lg
            margin: 5px
            width: auto
            padding: 5px
        .tab-active
            border: none
            &::before
                display: none
        .underline
            display: block
@media (min-width: 768px)
    .tabs
        .tab
            .tab-title
                width: 100%
                display: flex
                justify-content: center
                align-items: center
        .tab-sm
            margin: 2px 5px
            padding: 2px
        .tab-md
            margin: 5px 15px
        .tab-lg
            margin: 5px 20px
</style>
